import React, { useEffect, useState } from "react";
import { fadeIn, slideIn, staggerContainer } from "../utils/motion";
import { motion } from "framer-motion";
import TruncateText from "../TruncateText";
import { useSelector } from "react-redux";

export default function ToolsSection  ({lang}) {

  
const [width, setWidth] = useState(window.innerWidth);
  
useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
//  console.log(window.innerWidth);
  return () => window.removeEventListener("resize", handleResize);
  

}, []);
const [more_, setMore_] = useState(false)
const [more, setMore] = useState(false)
const data = useSelector((state) => state.cart.constants);   
  return (
   <motion.section
    variants={staggerContainer()}
   initial='hidden'
   whileInView='show'
   viewport={{ amount: 0.25 }}
   dir="rtl"  
   className={`relative  mt-2  w-full`}>
 <span className='hash-span' id={'ToolsSection'}>
   
    </span>


       
       
<div  className={` flex gap-[3px] w-full`}>



<motion.div variants={slideIn('right', '', 0.1, 1)}  style={{height:`${(width/2)-3}px`,}} className={`relative bg-[#F4F4F4]  w-[50%] hover:bg-[#ffffff]`}>
<div className="w-full" >
<img
          src="img/hand-drill.png"
          alt="الهمداني أدوات كهربائية "
       width='90%'
       height='auto'
    className="absolute  z-1 top-[25%] xl:top-[18%] lg:top-[18%] md:top-[18%] sm:top-[25%] xs:top-[25%]  right-0 transition-all duration-300 ease-in-out hover:mr-[-7%] hover:rotate-6"
       />
       
<div dir={lang=== 'en' ? 'ltr' : "rtl"} className="flex w-full">
<div className={`${lang === 'en' ? '  pl-10' :'pr-10'} relative z-2 xl:w-[70%] lg:w-[70%] md:w-[70%] sm:w-full xs:w-full flex flex-col self-stretch my-auto text-[#323131] pt-3  xl:pt-10 lg:pt-10 md:pt-5 sm:pt-4 xs:pt-3 py-1`} >
                      
                      <motion.h2 variants={fadeIn('left','',1,0.7)} style={{fontFamily:'CairoExtraBold'}} className={`${lang === 'en' ? 'text-left' :'text-right'} text-[15px]  lg:text-[40px]  md:text-[30px]  sm:text-[20px]  xs:text-[15px] text-zinc-700 `} >
                     {  lang=== 'en' ? 'Electrical Tools' :'أدوات كهربائية'}
                      </motion.h2>
                      <motion.p style={{height:`${(width/2)/5}px`,overflowY:'auto',whiteSpace:more?'pre-wrap':''}} variants={fadeIn('left','',1,0.7)}  className={`${lang === 'en' ? 'text-left' :'text-right'} text-[8px] xl:text-[20px] lg:text-[16px] md:text-[13px] sm:text-[10px] xs:text-[8px]`} >
                 {    
                  lang=== 'en' ?  
                      
                        
                    data&&data.length ?
                        
                      
                      data&&data[2].value_en?.length > 100 ? 
                          <>
                        {more ? data&&data[2].value_en : TruncateText(data&&data[2].value_en , 100)}
                        <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                        
                        {more ?'Less' : 'More'}
                        
                        </span> 
                        </>
                        :data&&data[2].value_en 
                    
                     :''
    
    
    
                  : 
                    
    
                       data&&data.length ?
                        
                      
                        data&&data[2].value?.length > 100 ? 
                            <>
                          {more ? data&&data[2].value : TruncateText(data&&data[1].value , 100)}
                          <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                          
                      
                          { more ?  'الغاء' : 'المزيد'}
                          </span> 
                          </>
                          :data&&data[2].value 
                      
                       :''
                        }
    
                 
                   
                  
                      </motion.p>
                    </div>
</div>

</div>

</motion.div>



<motion.div variants={slideIn('left', '', 0.1, 1)} style={{height:`${(width/2)-3}px`,}} className={`relative bg-[#F4F4F4]  w-[50%] hover:bg-[#ffffff]`}>
<div className="w-full"  >
<img
          src="img/painting-cover.png"
          alt="الهمداني مواد البناء"
       width='100%'
       height='100%'
       style={{maxHeight:`${(width/2)-3}px`,}}
       />
  
  <img
          src="img/hand-paint.png"
          alt="الهمداني مواد البناء"
       width='100%'
       height='auto'
    className=" absolute  top-[4%] left-0 transition-all duration-300 ease-in-out hover:ml-[-1.5%] hover:-rotate-3"
       />

<div dir="rtl" className="absolute top-0 flex w-full">
<div dir={lang === 'en' ? 'ltr' :'rtl'}  className="w-[70%] flex flex-col self-stretch my-auto text-[#323131] pt-3  xl:pt-10 lg:pt-10 md:pt-5 sm:pt-4 xs:pt-3   pr-10 p-1 ">
                      
                      <motion.h2 variants={fadeIn('right','',1,0.7)}  style={{fontFamily:'CairoExtraBold'}} className={`${lang === 'en' ? 'text-left' :'text-right'} text-[15px]  lg:text-[40px]  md:text-[30px]  sm:text-[20px]  xs:text-[15px] text-zinc-700`}  >
                      {lang === 'en' ? 'Construct Tools' :'أدوات بناء'} 
                     
                      </motion.h2>
                      <motion.p style={{height:`${(width/2)/4}px`,overflowY:'auto',whiteSpace:more_?'pre-wrap':''}}  variants={fadeIn('right','',1,0.7)}  className={`${lang === 'en' ? 'text-left' :'text-right'} text-[8px] xl:text-[20px] lg:text-[16px] md:text-[13px] sm:text-[10px] xs:text-[8px]`} >
                      {
                  
                  lang=== 'en' ?  
                      
                        
                    data&&data.length ?
                        
                      
                      data&&data[1].value_en?.length > 100 ? 
                          <>
                        {more_ ? data&&data[1].value_en : TruncateText(data&&data[1].value_en , 100)}
                        <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore_(!more_)}} >
                        
                        {more_ ?'Less' : 'More'}
                        
                        </span> 
                        </>
                        :data&&data[1].value_en 
                    
                     :''
    
    
    
                  : 
                    
    
                       data&&data.length ?
                        
                      
                        data&&data[1].value?.length > 100 ? 
                            <>
                          {more_ ? data&&data[1].value : TruncateText(data&&data[1].value , 100)}
                          <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more_)}} >
                          
                          { more_ ?  'الغاء' : 'المزيد'}
                          
                          </span> 
                          </>
                          :data&&data[1].value 
                      
                       :''
                        }
    
                 
                   
                  
                      </motion.p>
                    </div>
</div>
</div>  
</motion.div>

</div>



    </motion.section>
  );
};


